module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/home-7b786bca0d227cbdff4d0936fc4ba04b.svg";